import React, { Fragment } from "react";
import PropTypes from "prop-types";
import AddIcon from "@material-ui/icons/Add";
import {
  TextField,
  Tooltip,
  IconButton,
  MenuItem,
  Button,
  Typography,
} from "@material-ui/core";
import FilterIcon from "mdi-material-ui/FilterOutline";

const R405InventoryItemIssuanceViewFilter = (props) => {
  return (
    <Fragment>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          alignItems: "center"
        }}
      >
        <div>
          <Typography variant="h5" color="primary" style={{ fontWeight: 700 }}>
            Items Issuances List
          </Typography>
        </div>
        <div
          style={{
            display: "flex",
            width: "70%",
            justifyContent: "flex-end",
          }}
        >
          <div>
            <Tooltip title="Table Filter">
              <IconButton
                style={{ marginLeft: "-10px" }}
                onClick={() => props.handleToggleTableFilter()}
              >
                <FilterIcon fontSize="default" color="primary" />
              </IconButton>
            </Tooltip>
          </div>
          <div
            style={{
              width: "30%",
            }}
          >
            <TextField
              select
              id="categoryId"
              name="categoryId"
              fullWidth
              label="Category"
              size="small"
              variant="outlined"
              onChange={props.handleChange}
              value={props.state.categoryId}
              error={!!props.state.categoryIdError}
              helperText={props.state.categoryIdError}
              disabled={props.state.isLoading}
            >
              <MenuItem value={-1}>All</MenuItem>
              {props.state.categoriesData &&
                props.state.categoriesData.map((item) => {
                  return (
                    <MenuItem key={item.id} value={item.id}>
                      {item.label || ""}
                    </MenuItem>
                  );
                })}
            </TextField>
          </div>
          <div>
            <Button
              style={{
                textTransform: "capitalize",
                marginLeft: 15,
                padding: 7.5,
                width: 110,
              }}
              onClick={() => props.onNewItemButtonClick()}
              color="primary"
              variant="contained"
            >
              <AddIcon /> Issuance
            </Button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

R405InventoryItemIssuanceViewFilter.propTypes = {
  state: PropTypes.object,
  handleChange: PropTypes.func,
  handleToggleTableFilter: PropTypes.func,
  onNewItemButtonClick: PropTypes.func,
};

R405InventoryItemIssuanceViewFilter.defaultProps = {
  state: {},
  handleChange: (fn) => fn,
  handleToggleTableFilter: (fn) => fn,
  onNewItemButtonClick: (fn) => fn,
};

export default R405InventoryItemIssuanceViewFilter;
